import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { applicationRouteNames } from '../../app/application-route-names';
import { MpsMaintenanceService } from '../services/mps-maintenance.service';

export const MpsMaintenanceGuard = () => {
  const router = inject(Router);
  const maintenanceService = inject(MpsMaintenanceService);

  return maintenanceService.isInMaintenance ? true : router.navigateByUrl(applicationRouteNames.home);
};
